import * as React from 'react';
import './Alert.scss';
import { Svg } from '@src/assets/svg/Svg';

export interface IProps {
    body: string;
}

export interface IFunctions {
    onClose: () => void;
}

export type IAllProps = IProps & IFunctions;

export const Alert: React.SFC<IAllProps> = ({ body, onClose }) =>
    <div className="Alert-wrap">

        <div className="alert-body">
            <span
                onClick={onClose}
                className="close-btn"
                dangerouslySetInnerHTML={{ __html: Svg.close(20) }}
            />
            <span dangerouslySetInnerHTML={{ __html: body }} />
        </div>

    </div>;

export default Alert;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/alert/Alert.tsx